<ion-app *ngIf="isReady">
    <div class="update-overlay" *ngIf="isUpdating">
        <div class="update-overlay__backdrop"></div>
        <div class="update-overlay__content">
            <div class="update-overlay__spinner-wrapper">
                <svg class="update-overlay__spinner" viewBox="0 0 100 100">
                    <circle
                        class="update-overlay__spinner-track"
                        cx="50"
                        cy="50"
                        r="42"
                        fill="none"
                        stroke-width="6"
                    />
                    <circle
                        class="update-overlay__spinner-progress"
                        cx="50"
                        cy="50"
                        r="42"
                        fill="none"
                        stroke-width="6"
                        [attr.stroke-dasharray]="2 * 3.14159 * 42"
                        [attr.stroke-dashoffset]="
                            2 * 3.14159 * 42 * (1 - updatePercent / 100)
                        "
                    />
                </svg>
                <span class="update-overlay__percent">
                    {{ updatePercent }}%
                </span>
            </div>
            <h2 class="update-overlay__title">
                {{ "app-update.title" | translate }}
            </h2>
            <p class="update-overlay__description">
                {{ "app-update.description" | translate }}
            </p>
        </div>
    </div>

    <div class="modal" *ngIf="anniversary && anniversary.length > 0">
        <div class="modal-overlay"></div>

        <div class="modal-content">
            <div class="content-wrapper">
                <svg
                    class="close"
                    (click)="anniversary = null"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        opacity="0.1"
                        width="40"
                        height="40"
                        rx="20"
                        fill="url(#paint0_linear)"
                    />
                    <path
                        d="M27 14.41L25.59 13L20 18.59L14.41 13L13 14.41L18.59 20L13 25.59L14.41 27L20 21.41L25.59 27L27 25.59L21.41 20L27 14.41Z"
                        fill="black"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear"
                            x1="40"
                            y1="0"
                            x2="-6.47832"
                            y2="29.9448"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#0069B4" />
                            <stop offset="1" stop-color="#0B578E" />
                        </linearGradient>
                    </defs>
                </svg>

                <h2 *ngIf="anniversary.self">
                    {{
                        "anniversary-modal.hey"
                            | translate: { name: anniversary[0].name }
                    }}
                </h2>
                <p *ngIf="anniversary.self">
                    {{
                        "anniversary-modal.congrats-self"
                            | translate
                                : { years: anniversary[0].anniversaryType }
                    }}
                </p>

                <h2 *ngIf="!anniversary.self && anniversary.length === 1">
                    {{
                        "anniversary-modal.congrats-colleague"
                            | translate
                                : {
                                      name: anniversary[0].name,
                                      years: anniversary[0].anniversaryType
                                  }
                    }}
                </h2>

                <h2 *ngIf="!anniversary.self && anniversary.length > 1">
                    {{
                        "anniversary-modal.congrats-colleagues-title"
                            | translate
                    }}
                </h2>
                <p *ngIf="!anniversary.self && anniversary.length > 1">
                    {{
                        "anniversary-modal.congrats-colleagues"
                            | translate
                                : {
                                      names: anniversary.firstPersons,
                                      last: anniversary.lastPerson
                                  }
                    }}
                </p>

                <div class="bottom-content-wrapper">
                    <div class="blue-circle"></div>

                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0 8L1.41 9.41L7 3.83V16H9V3.83L14.58 9.42L16 8L8 0L0 8Z"
                            fill="white"
                        />
                    </svg>

                    <div (click)="moreConfetti()" class="action-button">
                        <span>
                            {{ "anniversary-modal.more-confetti" | translate }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-accoding-handbooks></app-accoding-handbooks>
    <ion-router-outlet></ion-router-outlet>
</ion-app>
